import { render, staticRenderFns } from "./ManufacturerInfo.vue?vue&type=template&id=283f320f&"
import script from "./ManufacturerInfo.vue?vue&type=script&lang=js&"
export * from "./ManufacturerInfo.vue?vue&type=script&lang=js&"
import style0 from "./ManufacturerInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports